import { Card, CardActionArea, CardContent, CardMedia } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Gap } from "shared/ui/gap";
import { H6, SmallP } from "shared/ui/headings";
import { getViewport } from "../../../../vicoustic/utility/get-viewport";

const VideoCard = props => {
  const {
    ...video
  } = props

  return (
    <Card style={{ width: '100%' }}>
      <CardActionArea style={{ height: '100%' }} component={Link} to={`/videos/${video.id}`}>
        {video.mainImage && <CardMedia
          component="img"
          image={getViewport(video.mainImage.src, 'xs')}
          alt={video.title}
        />}
        <CardContent>
          <SmallP>{video.date}</SmallP>
          <H6><b>{video.title}</b></H6>
          <Gap x={0.5} />
          <SmallP>{video.description}</SmallP>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default VideoCard
